import { select, put, call } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";

import { selectAuthAccountId } from "../../selectors/auth";
import { fetchBrandSeriesSuccess, fetchBrandSeriesFailure, setDailyAverageBrandRangeValues } from "../slice";
import { scoresApi } from "../../../api/scores.api";
import { reduceBrandEveryDayRowsToSeries } from "../utils/brandEveryDayFromRows";
import { applySagaError } from "../../utils/saga";
import type { fetchBrandSeriesPayload } from "../payload.types";
import type { ScoreDailyAverageResponse } from "../response.types";



export function* fetchBrandSeriesSaga(action: PayloadAction<fetchBrandSeriesPayload>) {
  try {
    const days = action.payload.days;

    const userID: string | null = yield select(selectAuthAccountId);
    if (userID == null) return;

    const rows: ScoreDailyAverageResponse[] = yield call(scoresApi.fetchBrandScoreDays, {
      userID,
      days,
    });

    const { scoresByBrand, rangeValues } = reduceBrandEveryDayRowsToSeries(rows);

    yield put(setDailyAverageBrandRangeValues(rangeValues));
    yield put(fetchBrandSeriesSuccess(scoresByBrand));
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "scores.fetchBrandSeries",
      failureAction: fetchBrandSeriesFailure,
    });
  }
}